module.exports = __webpack_public_path__ + "img/rascrut-7.6ffaff1a.webp";